const liquid_variables = [
  {
    name: 'Retailer',
    sub_menu: [
      {
        name: 'Name',
        content: 'retailer.name'
      },
      {
        name: 'Phone',
        content: 'retailer.phone'
      },
      {
        name: 'Website URL',
        content: 'retailer.website_url'
      },
      {
        name: 'Address 1',
        content: 'retailer.location.addr1'
      },
      {
        name: 'Address 2',
        content: 'retailer.location.addr2'
      },
      {
        name: 'City',
        content: 'retailer.location.city'
      },
      {
        name: 'State',
        content: 'retailer.location.state'
      },
      {
        name: 'Zip code',
        content: 'retailer.location.zip'
      }
    ]
  },
  {
    name: 'Campaign',
    sub_menu: [
      {
        name: 'Name',
        content: 'campaign.name'
      },
      {
        name: 'Description',
        content: 'campaign.description'
      },
      {
        name: 'Start date',
        content: 'campaign.start_date'
      },
      {
        name: 'End date',
        content: 'campaign.end_date'
      }
    ]
  },
  {
    name: 'Brand',
    sub_menu: [
      {
        name: 'Name',
        content: 'brand.name'
      },
      {
        name: 'Support email address',
        content: 'brand.support_email_address'
      }
    ]
  }
]

export default liquid_variables
